import SectionWithTestimonialAndButton from './section-with-testimonial-and-button';

export default SectionWithTestimonialAndButton;
